import { withInstall } from '@park-ui/utils'
import Tooltip from './src/tooltip.vue'

export const ElTooltip = withInstall(Tooltip)
export * from './src/tooltip'
export * from './src/tokens'
export default ElTooltip
